/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Sound_OnInputs */

const vi_station_sound_on = /** @type {(inputs: Station_Sound_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Âm thanh đang bật`)
};

/**

* @param {Station_Sound_OnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_sound_on = /** @type {((inputs?: Station_Sound_OnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Sound_OnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_sound_on(inputs)
});